<template>
  <div>
    <v-row row wrap class="text-center">
      <v-col :cols="12">
        <el-select
          size="small"
          v-model="selectedShopId"
          filterable
          multiple
          placeholder="เลือกร้าน"
          class="mr-2"
          collapse-tags
          style="width: 300px"
        >
          <el-option
            v-for="item in shopList"
            :key="item.shop_id"
            :label="item.name"
            :value="item.shop_id"
          ></el-option>
        </el-select>

        <el-date-picker
          size="small"
          v-model="daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="dd/MM/yyyy"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
        ></el-date-picker>
        <el-button type="primary" class="ml-2" size="mini" @click="viewReport"
          >ค้นหา</el-button
        >
        <!--
        <el-button type="primary" class="ml-2" size="mini" @click="downloadReport">ดาวน์โหลด</el-button>
        -->
      </v-col>
    </v-row>

    <v-row class="my-5" v-if="showStat">
      <v-col :cols="12" class="pr-0">
        <el-card class="box-card mx-3">
          <v-row>
            <v-col class="text-center">
              <strong>ยอดขาย</strong>
              <br />
              <h4 class="mt-2">฿ {{ amount.revenue | numFormat("0,0.00") }}</h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>ค่าสินค้า</strong>
              <br />
              <h4 class="mt-2">฿ {{ amount.food | numFormat("0,0.00") }}</h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>ค่าจัดส่ง</strong>
              <br />
              <h4 class="mt-2">
                ฿
                {{ amount.delivery | numFormat("0,0.00") }}
              </h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>ยอด GP</strong>
              <br />
              <h4 class="mt-2">
                {{ amount.gp | numFormat("0,0.00") }}
              </h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>ยอดร้านค้า</strong>
              <br />
              <h4 class="mt-2">
                {{ (amount.food - amount.gp) | numFormat("0,0.00") }}
              </h4>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="text-center">
              <strong>PL</strong>
              <br />
              <h4 class="mt-2">
                {{ amount.pl | numFormat("0,0.00") }}
              </h4>
            </v-col>
          </v-row>
        </el-card>
      </v-col>
    </v-row>
    <el-card class="mt-3 mx-3 mb-5">
      <div slot="header" class="clearfix">
        <span>&nbsp;</span>
        <el-button
          icon="fas fa-file-download"
          v-if="orderList.length > 0"
          style="float: right; padding: 3px 0"
          type="text"
          @click="downloadReport"
          >&nbsp;ดาวน์โหลด</el-button
        >
      </div>

      <v-data-table
        :headers="headers"
        :items="orderList"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-center">
            <img src="@/assets/img/no-order.png" style="width: 30%" />
          </div>
        </template>

        <template v-slot:item.order_type="{ item }">
          <div style="min-height: 60px; width: 140px">
            <div class="pt-3">
              <el-tooltip
                content="เดลิเวอรี่"
                placement="top"
                v-if="item.order_type == 'delivery'"
              >
                <i class="fas fa-motorcycle mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="คอมเมิร์ซ"
                placement="top"
                v-if="item.order_type == 'commerce'"
              >
                <i class="fas fa-shopping-bag mr-2"></i>
              </el-tooltip>
              <el-tooltip
                content="รับเองที่ร้าน"
                placement="top"
                v-if="item.order_type == 'pickup'"
              >
                <i class="fas fa-store mr-2"></i>
              </el-tooltip>

              <el-tooltip
                content="สั่งจาก POS"
                placement="top"
                v-if="['dinein', 'dinein-buffet'].includes(item.order_type)"
              >
                <i class="fas fa-desktop mr-2"></i>
              </el-tooltip>

              <span class="grey--text">{{ item.order_reference }}-</span>
              {{ item.order_id | numFormat("00000") }}
            </div>

            <div
              v-if="item.status == 'cancelled'"
              class="grey lighten-2 badge-status"
            >
              ยกเลิกแล้ว
            </div>
            <div
              v-if="item.status == 'pending'"
              class="grey darken-2 badge-status"
            >
              <i class="far fa-clock"></i> รอชำระเงิน
            </div>
            <div v-else-if="item.status == 'new'" class="red badge-status">
              มาใหม่
            </div>
            <div
              v-if="item.status == 'accepted' || item.status == 'captured'"
              class="amber darken-1 badge-status"
            >
              ยืนยันแล้ว
            </div>
            <div
              v-if="item.status == 'processing'"
              class="blue darken-2 badge-status"
            >
              ส่งให้ร้านแล้ว
            </div>
            <div
              v-if="item.status == 'cooking'"
              class="blue darken-4 badge-status"
            >
              กำลังดำเนินการ
            </div>
            <div
              v-if="item.status == 'ready-to-go'"
              class="pink lighten-3 badge-status"
            >
              พร้อมจัดส่ง
            </div>
            <div
              v-if="item.status == 'delivering'"
              class="pink lighten-1 badge-status"
            >
              กำลังจัดส่ง
            </div>
            <div
              v-if="item.status == 'completed'"
              class="green lighten-1 badge-status"
            >
              เรียบร้อยแล้ว
            </div>
          </div>
        </template>

        <template v-slot:item.datetime_received="{ item }">
          <!-- เวลารับอาหาร -->
          <div style="width: 150px">
            <div>{{ item.datetime_received | moment("DD/MM/YY HH:mm") }}</div>
            <div v-if="item.cluster_id != null">
              <el-tag
                v-if="
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                "
                size="mini"
                type="info"
                >รอบส่ง
                {{
                  item.shop.cluster_json.find((x) => x.id == item.cluster_id)
                    .delivery
                }}</el-tag
              >
            </div>
            <div v-if="item.driver_info_json != null">
              <a
                v-if="item.driver_type == 'lalamove'"
                :href="
                  `https://share.lalamove.com/?TH` +
                    item.driver_info_json.orderRef +
                    `&lang=th_TH`
                "
                target="_blank"
              >
                <img src="@/assets/img/icon-lalamove.png" style="width: 20px" />
              </a>

              <img
                v-if="item.driver_type == 'grab-instant'"
                src="@/assets/img/icon-grab-instant.png"
                style="width: 20px"
              />
            </div>
          </div>
        </template>

        <template v-slot:item.user_ref_json="{ item }">
          <!-- ข้อมูลลูกค้า -->

          <div v-if="['dinein', 'dinein-buffet'].includes(item.order_type)">
            <strong>{{ item.custom_5 }}</strong>
          </div>
          <div v-else style="width: 120px">
            <template v-if="item.user_ref_json != null">
              <strong class="line-1-elipsis"
                >{{ item.user_ref_json.firstname }}
                {{ item.user_ref_json.lastname }}</strong
              >
              <div>
                <span class="font-xs">
                  <i class="fas fa-mobile-alt"></i>
                  {{ item.user_ref_json.mobile }}
                </span>
              </div>
            </template>
          </div>
        </template>

        <template v-slot:item.gp_amount="{ item }">
          ฿ {{ item.gp_amount | numFormat("0.00") }}
        </template>
        <template v-slot:item.pl_amount="{ item }">
          ฿ {{ item.pl_amount | numFormat("0.00") }}
        </template>
      </v-data-table>

      <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import Service from "@/services";
import moment from "moment";
export default {
  components: {},
  props: {
    shop: { default: false },
    showStat: { default: false },
    gp: { default: false },
  },
  data() {
    return {
      mode: null,
      loading: null,
      isLoading: false,
      daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      selectedShopId: null,
      orderList: [],
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      amount: {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
        lalamove: 0,
      },
      permission: null,
      shopList: [],
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "order_type",
        },
        { text: "", value: "action", sortable: false },
        { text: "วันเวลา", value: "datetime_received", sortable: false },
        { text: "ร้านอาหาร", value: "shop_name", sortable: false },
        { text: "จำนวนเงิน", value: "amount.food", sortable: false },
        { text: "ค่าจัดส่ง", value: "amount.delivery", sortable: false },
        { text: "ส่วนลด", value: "amount.discount", sortable: false },
        { text: "ค่าพนักงานขับรถ", value: "driver_fee", sortable: false },
        { text: "GP", value: "gp_amount", sortable: false },
        { text: "PL", value: "pl_amount", sortable: false },
      ],
      statusOrdering: [
        "pending",
        "new",
        "acccepted",
        "cooking",
        "processing",
        "completed",
        "cancelled",
      ],
    };
  },
  created() {
    Service.User.permission().then((resp) => {
      this.permission = resp.data;
      this.mode = this.permission.user.role_id;

      Service.Shop.gets().then((res) => {
        /*
        this.shopList = res.data.filter(function(item) {
          return item.status == "published";
        });
        */
        this.shopList = res.data;

        this.shopList.sort(function(a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        /*
        this.shopList = this.shopList.filter(item => {
          return item.ent_id == this.permission.enterprises[0].ent_id;
        });
        */
      });
    });
  },
  methods: {
    viewReport() {
      this.showLoading();

      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "view",
      };
      if (this.selectedShopId.length > 0) {
        params.shop_id = this.selectedShopId;
      }
      this.amount = {
        revenue: 0,
        delivery: 0,
        delivery_tax: 0,
        food: 0,
        extra: 0,
        cog: 0,
        quantity: 0,
        completed: 0,
        lalamove: 0,
        gp: 0,
        pl: 0,
      };
      Service.Report.gpAdmin(params)
        .then((res) => {
          this.orderList = res.data;

          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );

          this.orderList.map((item) => {
            if (item.status == "completed") {
              this.amount.revenue += parseFloat(item.amount.total);
              this.amount.delivery += parseFloat(item.amount.delivery);
              //this.amount.delivery_tax += parseFloat(item.amount.delivery_tax);
              this.amount.food += parseFloat(item.amount.food);
              this.amount.extra += parseFloat(item.amount.extra);
              this.amount.discount += parseFloat(item.amount.discount);
              this.amount.completed++;

              if (item.gp_amount != 0 || item.gp_amount != null) {
                this.amount.gp += parseFloat(item.gp_amount);
              }
              if (item.pl_amount != 0 && item.pl_amount != null) {
                this.amount.pl += parseFloat(item.pl_amount);
              }
            }
          });
          this.hideLoading();
        })
        .catch((e) => {
          this.hideLoading();
        });
    },
    downloadReport() {
      this.showLoading();
      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        report: true,
        type: "download",
      };

      if (this.selectedShopId.length > 0) {
        params.shop_ids = this.selectedShopId;
      }

      var queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
      let accessToken = vuex.Auth.accessToken;

      var request = new XMLHttpRequest();

      request.responseType = "blob";
      request.onreadystatechange = (e) => {
        let _ = this;
        let filename = "ยอดขายทั้งหมด_";
        if (this.selectedShopId != null && this.selectedShopId.length == 1) {
          let filename = _.shopList.find((x) => x.shop_id == _.selectedShopId)
            .name;
        }
        if (request.readyState !== 4) {
          return;
        }
        if (request.status === 200) {
          //console.log("success", request.response);
          var fileURL = window.URL.createObjectURL(
            new Blob([request.response], {
              type: "application/vnd.ms-excel",
            })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sale_report_" + filename + ".xls");
          document.body.appendChild(fileLink);

          _.hideLoading();
          fileLink.click();
        } else {
          console.warn(request);
        }
      };

      request.onload = function(oEvent) {
        var blob = request.response;
      };

      request.open(
        "GET",
        "https://report-api.halalize.com/delivery/gp?" + queryString
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + accessToken);
      //request.setRequestHeader("Accept", "*/*");
      //request.setRequestHeader("Origin", "dev-admin.foodhunt.com");
      //request.setRequestHeader("Host", "dev-order-api.foodhunt.com");
      request.send();
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    hideLoading() {
      this.loading.close();
    },
  },
};
</script>
